const EMPLOYER_TYPE = {
  DOMESTIC: 0,
  FOREIGN: 1,
  INDIVIDUAL: 2,
  FOREIGN_INDIVIDUAL: 3,
  OTHER: 4,
};

export default EMPLOYER_TYPE;
